import { RawRewardAccount, RewardAccount, StakeAddress } from "./address";

export type Withdrawls = Map<RawRewardAccount, number | bigint>;

type RawWithdrawal = Map<RawRewardAccount, bigint>;

export class Withdrawal {
  rewards: Map<RewardAccount, bigint>;
  constructor(rewards: Map<RewardAccount, bigint>) {
    this.rewards = rewards;
  }
  static fromCborObject(obj: RawWithdrawal): Withdrawal {
    const newMap = new Map<RewardAccount, bigint>();
    obj.forEach((deposit, rewardAccount) => {
      const parsedRewardAccount = StakeAddress.fromBytes(rewardAccount);
      newMap.set(parsedRewardAccount, deposit);
    });
    return new Withdrawal(newMap);
  }
}

export function parseWithdrawals(rawWithdrawals: RawWithdrawal[]): Withdrawal[] {
  const withdrawals: Withdrawal[] = [];
  rawWithdrawals.forEach((rawWithdrawal) => {
    withdrawals.push(Withdrawal.fromCborObject(rawWithdrawal));
  });
  return withdrawals;
}